'use strict';

$(document).ready(function () {
    $(document).on('click', function (event) {
        if ($(event.target).is('[disabled]')) {
            return;
        }

        if ($(event.target).is('ul.custom-options.sort-custom-options') || $(event.target).is('.sort-icon use')) {
            return;
        }

        if (!($(event.target).is('.custom-drop-down, .selected-value, .down-arrow, .custom-drop-down .sort-down, .sort-by-text, .sort-icon, .sort-text, .sort-heading-section, .custom-drop-down-sticky, path'))) {
            $('.custom-option-values').hide();
            $('.down-arrow').removeClass('rotate-arrow');
            $('.custom-drop-down').removeClass('opened');

            if ($(event.target).is('.sort-custom-options')) {
                $('.modal-background').hide();
                $('body').removeClass('overflow-hidden');
            }
        }
    });
    $(document).on('click', '.custom-drop-down', '.down-arrow', function () {
        var $this = $(this);
        var $options = $this.parent().find('.custom-option-values');
        var $allOptions = $('.custom-option-values');
        var $customDropDown = $('.custom-drop-down');

        if (!$this.hasClass('opened') && $customDropDown.is('.opened')) {
            $customDropDown.removeClass('opened');
            $customDropDown.find('.down-arrow').removeClass('rotate-arrow');
        }

        if ($options.css('display') !== 'block') {
            $allOptions.hide();
            $this.next().show();
            $('.custom-option-values ul').scrollTop(0);
            $this.addClass('opened');
            $this.find('.down-arrow').addClass('rotate-arrow');
        } else if ($this.hasClass('opened')) {
            $this.find('.down-arrow').removeClass('rotate-arrow');
            $this.parent().find('.custom-option-values').css('display', 'none');
            $this.removeClass('opened');
        }
    });
    $(document).on('click', '.custom-option-value', function () {
        let optionValue = $(this);
        if (!optionValue.is('[disabled]')) { // Run only if not disabled
            var $optionValues = optionValue.closest('.custom-option-values');
            var selectedValue = $optionValues.prev().find('.selected-value');
            var $traditionalSelect = $(this).parents('.custom-drop-down-section').prev();
            $optionValues.hide();
            $(this).parent().find('.custom-option-value').removeClass('selected');
            optionValue.addClass('selected');
            $optionValues.prev().find('.down-arrow').removeClass('rotate-arrow');
            $traditionalSelect.find('option[selected=selected]').removeAttr('selected');
            $traditionalSelect.find('option[data-id="' + $(this).attr('data-id') + '"]').attr('selected', ' ');
            $traditionalSelect.trigger('change');
            if ($(this).closest('.custom-options').hasClass('title-select')) {
                selectedValue.text(optionValue.find('.title').text()).removeClass('d-none');
            } else if (selectedValue.hasClass('custom-searchable-input')) {
                selectedValue.val(optionValue.text().trim()).removeClass('d-none').attr('value', optionValue.text().trim()).trigger('change');
            } else {
                selectedValue.text(optionValue.text()).removeClass('d-none');
            }
            if ($('.page').data('action') === 'Search-Show' && $(this).parents().closest('.custom-drop-down-section').find('.sort-by-text').length > 0) {
                $('.sort-by-text .selected-value').text(optionValue.text()).removeClass('d-none');
            }
            $optionValues.hide();
            $optionValues.prev().removeClass('opened');
        }
    });

    $(document).on('click', '.custom-searchable-dropdown-section .custom-drop-down, .custom-searchable-dropdown-section .down-arrow', function () {
        const $section = $(this).closest('.custom-searchable-dropdown-section');
        const $ul = $section.find('.custom-options');
        const selectedText = $section.find('.custom-option-value.selected').text().trim();

        // Store original list ONLY ONCE
        if (!$section.data('originalList')) {
            let list = [];
            $section.find('.custom-option-value').each(function () {
                list.push($(this).clone());
            });
            $section.data('originalList', list);
        }

        const originalList = $section.data('originalList');

        // Reset dropdown
        $ul.empty();

        $.each(originalList, function (_, $el) {
            const $clone = $el.clone();

            // Maintain selected state
            if ($clone.text().trim() === selectedText) {
                $clone.addClass('selected');
            } else {
                $clone.removeClass('selected');
            }

            $ul.append($clone);
        });
    });

    $(document).on('blur', '.custom-searchable-input', function () {
        const $section = $(this).closest('.custom-searchable-dropdown-section');
        const $input = $(this);

        var countryText = $section.find('.custom-option-value.selected').text().trim();

        $input.val(countryText).attr('value', countryText).trigger('change');
    });

    $(document).on('input', '.custom-searchable-input', function () {
        let value = $(this).val();
        var $customSearchableDropSection = $(this).closest('.custom-searchable-dropdown-section');

        // Get function name dynamically
        const functionName = $customSearchableDropSection.data('on-select');

        $customSearchableDropSection.find('.custom-drop-down').addClass('opened');
        $customSearchableDropSection.find('.down-arrow').addClass('rotate-arrow');
        $customSearchableDropSection.find('.custom-option-values').css('display', 'block');

        // Allow only alphabets + spaces
        value = value.replace(/[^a-zA-Z ]/g, '');

        // Prevent starting space
        value = value.replace(/^\s+/, '');

        // Single space only
        value = value.replace(/\s{2,}/g, ' ');

        $(this).val(value);

        const searchValue = value.toLowerCase().trim();

        const $ul = $customSearchableDropSection.find('.custom-options');
        const $items = $customSearchableDropSection.find('.custom-option-value');

        if (!searchValue) {
            const selectedText = $customSearchableDropSection.find('.custom-option-value.selected').text().trim();
            const originalList = $customSearchableDropSection.data('originalList');

            if (originalList) {
                $ul.empty();
                $.each(originalList, function (_, $el) {
                    const $clone = $el.clone();

                    if ($clone.text().trim() === selectedText) {
                        $clone.addClass('selected');
                    } else {
                        $clone.removeClass('selected');
                    }
                    $ul.append($clone);
                });
            }
            return;
        }

        const startsWith = [];
        const others = [];

        $items.each(function () {
            const $item = $(this);
            const text = $item.text().toLowerCase().trim();

            if (text.startsWith(searchValue)) {
                startsWith.push($item);
            } else {
                others.push($item);
            }
        });

        // Reorder only
        $ul.empty();

        $.each(startsWith, function (_, $el) {
            $ul.append($el);
        });

        $.each(others, function (_, $el) {
            $ul.append($el);
        });

        $ul.scrollTop(0);

        const $updatedItems = $customSearchableDropSection.find('.custom-option-value');

        const $exactMatch = $updatedItems.filter(function () {
            var text = $(this).text().toLowerCase().trim();
            return text === searchValue;
        });

        if ($exactMatch.length === 1) {
            $updatedItems.removeClass('selected');
            $exactMatch.addClass('selected');

            if (functionName) {
                window[functionName]($exactMatch);
            }
        }
    });
});
